(function initKlaviyoBackInStock() {
  if (typeof klaviyo === "undefined" || typeof klaviyo.enable !== "function") {
    // klaviyo aún no está listo, reintenta en 50ms
    setTimeout(initKlaviyoBackInStock, 50);
    return;
  }

  klaviyo.init({
    account: "SQLRJ3",
    platform: "shopify",
  });

  klaviyo.enable("backinstock", {
    trigger: {
      product_page_text: "Avísame cuando esté disponible",
      product_page_class: "",
      product_page_text_align: "center",
      product_page_margin: "0px",
      replace_anchor: false,
    },
    modal: {
      headline: "{product_name}",
      body_content:
        "¡Recibe una notificación cuando vuelva a estar disponible!",
      email_field_label: "Dirección de correo electrónico",
      button_label: "Enviar",
      subscription_success_label:
        "¡Listo! Te avisaremos cuando esté de vuelta.",
      footer_content: "",
      additional_styles: "", // ← El asset_url de Liquid no funciona en JS externo.
      //   Mueve los estilos al CSS del tema directamente.
      drop_background_color: "#000",
      background_color: "#fff",
      text_color: "#222",
      button_text_color: "#FFFFFF",
      button_background_color: "#da5c15",
      close_button_color: "#ccc",
      error_background_color: "#fff8f8",
      error_text_color: "#d20000",
      success_background_color: "#F8FFF9",
      success_text_color: "#1F873D",
    },
  });
})();
